import Vimeo from "@u-wave/react-vimeo"
import PropTypes from "prop-types"
import React from "react"
import './vimeoplayer.scss'

const VimeoPlayer = ({ videoId, autoplay }) => (
  <div className="embed-responsive embed-responsive-16by9">
    <Vimeo
      className='embed-responsive-item'
      video={videoId}
      autoplay={autoplay}
    />
  </div>
)

VimeoPlayer.propTypes = {
  videoId: PropTypes.number,
  autoplay: PropTypes.bool,
}

VimeoPlayer.defaultProps = {
  videoId: ``,
  autoplay: false,
}

export default VimeoPlayer
